export default __webpack_public_path__ + "static/media/img_summary_01_m.54a6f609.webp";